var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import setServiceEntryInProgress from '../../requests/service/setServiceEntryInProgress';
/**
 *
 */
var SetServiceEntryInProgressCommand = /** @class */ (function (_super) {
    __extends(SetServiceEntryInProgressCommand, _super);
    function SetServiceEntryInProgressCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param data Object
     * @param organisation OrganisationModel
     * @param serviceEntryModel ServiceEntryModel
     * @param intl
     * @return {*}
     */
    SetServiceEntryInProgressCommand.prototype.execute = function (data, organisation, serviceEntryModel, intl) {
        this.data = data;
        this.intl = intl;
        this.serviceEntryModel = serviceEntryModel;
        var promise = setServiceEntryInProgress(data, organisation, serviceEntryModel);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    SetServiceEntryInProgressCommand.prototype.then = function (response) {
        this.serviceEntryModel.update(response);
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.service.entry.updated' }), 'dark', true);
        Signals.ServiceEntryUpdated.dispatch(this.serviceEntryModel);
    };
    return SetServiceEntryInProgressCommand;
}(Command));
export default SetServiceEntryInProgressCommand;
